import React from 'react'
import './SectionNavbar.scss'

const SectionNavbar = ({title, background, children}) => {
    return (
        <div className='sectionNavbar card'>
            {children}
        </div>
    )
}

export default SectionNavbar
